import { Input as ShadcnInput } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface InputProps extends React.ComponentProps<'input'> {
	error?: string
}

export function Input({ error, className, ...props }: InputProps) {
	return (
		<div className="flex flex-col gap-1">
			<ShadcnInput
				className={cn(
					'h-9 text-sm border-border focus-visible:ring-0 focus-visible:border-primary',
					error && 'border-error focus-visible:border-error',
					className,
				)}
				{...props}
			/>
			{error && <span className="text-xs text-error">{error}</span>}
		</div>
	)
}
